var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"logoUrl":_vm.logoUrl}}),_c('router-view'),_c('Footer',{attrs:{"videoUrl":_vm.videoUrl,"brochureUrl":_vm.brochureUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }